import BehaviorConfig from '@/models/app-config/behavior/behavior'
import { BadgeListDisplayPolicy } from '@/models/badge-list/display-policy'
import { MyColorBadgeListDisplayPolicy } from '@/models/badge-list/each-policy/mycolor-policy'
import { HlBadgeListDisplayPolicy } from '../each-policy/hl-policy'

export const createBadgeListPolicy = (
  behavior: BehaviorConfig
): BadgeListDisplayPolicy => {

  if (behavior.isLikeHotellovers) return new HlBadgeListDisplayPolicy(behavior)

  return new MyColorBadgeListDisplayPolicy(behavior)
}
